<template>
  <div class="ar-aside" :style="{ width }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ArAside',

  componentName: 'ArAside',

  props: {
    width: {
      type: String,
      default: '200px'
    }
  }

};
</script>


// WEBPACK FOOTER //
// src/components/anyUI/aside/aside.vue